export default {
    hexDesc: {
        title: "HEXTRIS",
        desc: [
            "一个类似俄罗斯方块的同色相消的小游戏，进入后左上角可以查看玩法和源码地址，暂时不支持服务器保留分数，" +
            "每个人的分数只会保留在本地，之后会加入网络最高分系统。建议使用电脑游玩，手机没有加速键（有机会会增加）," +
            "可能没有办法拿到比较高的分数"
        ]
    },

    mikDesc: {
        title: "MIKUTAP",
        desc: [
            "解压游戏，一个日本人开发的的音乐模拟向的游戏，通过点击和滑动触发不同的音阶以及生成不同的画面，" +
            "右上角可以进入全屏，配合手机或全屏一起食用效果更佳"
        ]
    }
}